import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncPermissionsAdmin = AsyncComponent(() =>
  import('./PermissionsAdmin')
);
const AsyncUser = AsyncComponent(() => import('./User'));
const AsyncUsers = AsyncComponent(() => import('./Users'));
const AsyncCreateUser = AsyncComponent(() => import('../CreateAccountMain'));
const AsyncClientAreaUserServiceAssignment = AsyncComponent(() =>
  import('./ClientAreaUserServiceAssignment')
);
const AsyncBrokers = AsyncComponent(() => import('./Brokers'));
const AsyncPositions = AsyncComponent(() => import('./Positions'));
const AsyncGroups = AsyncComponent(() => import('./Groups'));
const AsyncDepartments = AsyncComponent(() => import('./Departments'));
const AsyncCreateLoanApplication = AsyncComponent(() =>
  import('./CreateLoanApplication')
);

export {
  AsyncPermissionsAdmin,
  AsyncUser,
  AsyncUsers,
  AsyncCreateUser,
  AsyncClientAreaUserServiceAssignment,
  AsyncBrokers,
  AsyncPositions,
  AsyncGroups,
  AsyncDepartments,
  AsyncCreateLoanApplication,
};



// WEBPACK FOOTER //
// ./src/pages/Admin/index.js